import { z } from 'zod/v4';

export const BulkArchiveActionsRequestSchema = z.object({
  actionIds: z
    .array(z.string().min(1, 'Action ID is required'))
    .min(1, 'At least one action ID is required')
    .max(100, 'Maximum 100 action IDs allowed per request'),
});

export type BulkArchiveActionsRequest = z.infer<
  typeof BulkArchiveActionsRequestSchema
>;

export const BulkArchiveActionsQuerySchema = z.object({
  includeLinkedActions: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .optional()
    .default(false)
    .transform(val => val === true || val === 'true'),
});

export type BulkArchiveActionsQuery = z.infer<
  typeof BulkArchiveActionsQuerySchema
>;
